<script>
import { required, url } from "vuelidate/lib/validators";
// Custom Components
import superService from "@/helpers/APIService/super.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";

export default {
  data() {
    return {
      pms_form: {
        hotel: "",
        pms_type: "",
        login_url: "",
        customer_code: "",
        user_name: "",
        password: "",
        is_active: true,
      },
      pmsTypeOptions: ["jonas_chorum_pms", "choice_advantage_pms", "asi_pms"],
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
    };
  },
  props: {
    pmsForm: Object,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    pms_form: {
      pms_type: { required },
      login_url: { required, url },
      customer_code: { required },
      user_name: { required },
      password: { required },
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.isEdit) {
        Object.keys(this.pmsForm).map((key) => {
          if (this.pmsForm[key] !== null || this.pmsForm[key] !== undefined) {
            this.pms_form[key] = this.pmsForm[key];
          }
        });
      }
    },
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {};
        Object.keys(this.pms_form).map((key) => {
          if (this.pms_form[key] !== null && this.pms_form[key] !== undefined) {
            if (this.isEdit) {
              if (this.pms_form[key] !== this.pmsForm[key])
                data[key] = this.pms_form[key];
            } else {
              data[key] = this.pms_form[key];
            }
          }
        });
        if (this.isEdit) {
          superService
            .updatePMSConn(this.pmsForm.id, data)
            .then((response) => {
              this.isBtnLoading = false;
              Middleware.notification("Successfully updated !!", "success");
              this.$emit("submitted", response);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          superService
            .addPMSConn(data)
            .then((response) => {
              this.isBtnLoading = false;
              Middleware.notification("Successfully added !!", "success");
              this.$emit("submitted", response);
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ this.isEdit ? "Update" : "Add New" }} PMS connection</h4>
        <hr />

        <div class="row">
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="pms_serve">
              <span slot="label">
                PMS Type <span class="text-danger">*</span></span
              >
              <b-form-select
                class="form-select"
                id="pms_type-input"
                type="text"
                autocomplete="off"
                v-model="pms_form.pms_type"
                :options="pmsTypeOptions"
                :class="{
                  'is-invalid': submitted && $v.pms_form.pms_type.$error,
                }"
              >
              </b-form-select>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pms_form.pms_type.required"
                  >PMS Type is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="login_url">
              <span slot="label">
                Login URL <span class="text-danger">*</span></span
              >
              <b-form-input
                id="login_url"
                type="url"
                autocomplete="off"
                v-model="pms_form.login_url"
                :class="{
                  'is-invalid': submitted && $v.pms_form.login_url.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pms_form.login_url.required"
                  >Login Url is required.</span
                >
                <span v-if="!$v.pms_form.login_url.url">Enter valid url.</span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="customer_code">
              <span slot="label">
                Customer Code <span class="text-danger">*</span></span
              >
              <b-form-input
                id="customer_code"
                type="text"
                autocomplete="off"
                v-model="pms_form.customer_code"
                :class="{
                  'is-invalid': submitted && $v.pms_form.customer_code.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pms_form.customer_code.required"
                  >Customer Code is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="user_name">
              <span slot="label">
                User Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="user_name"
                type="text"
                autocomplete="off"
                v-model="pms_form.user_name"
                :class="{
                  'is-invalid': submitted && $v.pms_form.user_name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pms_form.user_name.required"
                  >User Name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="password">
              <span slot="label">
                Password <span class="text-danger">*</span></span
              >
              <b-form-input
                id="password"
                type="text"
                autocomplete="off"
                v-model="pms_form.password"
                :class="{
                  'is-invalid': submitted && $v.pms_form.password.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pms_form.password.required"
                  >Password is required.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <div class="mb-3">
              <label for="is_active">Active</label>
              <div class="form-check form-switch my-1" slot="is_active">
                <input
                  class="form-check-input"
                  id="is_active"
                  type="checkbox"
                  v-model="pms_form.is_active"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <b-alert v-if="isError" show variant="danger">
              <ul>
                <li v-for="(error, index) in errorMessage" :key="index">
                  {{ index }}: {{ error[0] }}
                </li>
              </ul>
            </b-alert>
          </div>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ this.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
